import { FIELDS, TAB_ORDER } from '../../lib/windgram';

/**
 * WindgramTabs — tab bar matching Skysight's left-to-right tab order.
 *
 * A single non-wrapping row that scrolls horizontally when the tabs overflow
 * (both desktop and mobile) — never wraps onto a second line.
 *
 * Props:
 *   value      — active FIELDS key (e.g. 'overview')
 *   onChange   — called with the FIELDS key when a tab is clicked
 *   t          — i18n translation function
 *   hiddenTabs — FIELDS keys to omit (e.g. ['ti'] on ICON, which has no
 *                thermal-index data — verified 2026-06-11)
 */
const WindgramTabs = ({ value, onChange, t, hiddenTabs = [] }) => {
    const activeClass = 'bg-blue-600 text-white';
    const inactiveClass =
        'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 hover:bg-blue-50 dark:hover:bg-slate-600';
    const baseClass =
        'px-3 py-1.5 text-xs font-medium rounded whitespace-nowrap transition-colors focus:outline-none';

    const tabs = TAB_ORDER.filter((key) => !hiddenTabs.includes(key)).map((key) => (
        <button
            key={key}
            type="button"
            className={`${baseClass} ${value === key ? activeClass : inactiveClass}`}
            onClick={() => onChange(key)}
        >
            {t(FIELDS[key].label)}
        </button>
    ));

    return (
        // Always a single non-wrapping row that scrolls horizontally when the
        // tabs don't fit (desktop + mobile) — never wraps to a second line.
        <div className="flex flex-row flex-nowrap gap-1 p-2 overflow-x-auto">
            {tabs}
        </div>
    );
};

export default WindgramTabs;
